export const waitForCanvas3DReady = async (
  getCanvas3D,
  {
    timeoutMs = 4000,
    pollIntervalMs = 100,
    requiredMethods = [],
  } = {}
) => {
  let elapsedMs = 0;

  while (elapsedMs <= timeoutMs) {
    const canvas3D = getCanvas3D?.();
    const hasRequiredMethods = requiredMethods.every(
      (methodName) => typeof canvas3D?.[methodName] === 'function'
    );

    if (canvas3D?.isLoaded === true && hasRequiredMethods) {
      return canvas3D;
    }

    if (elapsedMs === timeoutMs) {
      break;
    }

    const delayMs = Math.min(pollIntervalMs, timeoutMs - elapsedMs);
    await new Promise((resolve) => setTimeout(resolve, delayMs));
    elapsedMs += delayMs;
  }

  return null;
};
